<template>
    <div>
        <b-modal
            id="modalidexxsubmit"
            ref="modalidexxsubmit"
            :key="modalKey"
            :lazy="true"
            @shown="shown"
            @hide="close"
            title-tag="h2"
            hide-footer
            size="lg"
            centered
            no-close-on-backdrop
        >
            <div
                slot="modal-header"
                class="d-flex justify-content-between w-100"
            >
                <h2 class="d-md-block d-none my-2">IDEXX VetConnects</h2>
                <span class="align-self-center text-danger">
                    <button class="btn btn-primary" @click="close">Exit</button>
                </span>
            </div>
            <div class="modal-body" style="min-height: 5rem;">
                <div
                    id="modalidexxwidget"
                    style="min-width: 650px; height: 550px; overflow-y: hidden;"
                >
                    <iframe
                        id="mmResultFrame"
                        v-if="data && data.idexx_url"
                        :src="iframe.src"
                        :height="iframe.style.height"
                        :width="iframe.style.width"
                        @load="load(data)"
                        frameborder="0"
                    ></iframe>
                </div>
            </div>
            <!-- </div> -->
        </b-modal>
        <!-- <multipleRequisitionForm ref="multipleRequisitionFormWindow" /> -->
        <!-- <requisitionForm ref="requisitionFormWindow" /> -->
        <!-- <idexxSubmit ref="modalIdexxSubmit2" /> -->
    </div>
</template>
<script>
// import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
// import RequisitionForm from "@/module/commons/print_requisition_form.vue";
// import IdexxSubmit from "@/module/commons/idexx_submit.vue";
import ScheduleHelper from "@/module/schedule/helper";
import { isEmpty } from "lodash";

export default {
    components: {
        // MultipleRequisitionForm,
        // RequisitionForm
        // IdexxSubmit
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            modalKey: 0,
            data: null,
            allowCloseDialog: true,
            iframe: {
                src: "",
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "550px"
                },
                wrapperStyle: {
                    overflow: "hidden"
                }
            },
            global_idexx_params: null
        };
    },
    mounted() {
        // this.addScript('//merckbooks.com/vetsearchwidget/vetsearchwidgethSSL.js?query=vetterSoftware')
    },
    methods: {
        shown() {
            let self = this;
        },
        open(params) {
            let self = this;

            self.data = params;

            this.$refs.modalidexxsubmit.show();
            this.allowCloseDialog = true;

            let i = params.counter;
            let idexx_lab_id = params.idexx_lab_id;
            let lab_ids = params.lab_ids;
            let mod = params.module;
            let type = params.type;
            let url = params.module_url;
            let urls = params.idexx_url;

            //load first idexx url if available
            if (urls[i]) {
                this.iframe.src = urls[i];
                this.iframe.style = {
                    position: "absolute",
                    width: "100%",
                    height: "550px"
                };
                this.iframe.wrapperStyle = {
                    overflow: "hidden"
                };
            }
        },
        // add slight delay to prevent load function
        // being executed multiple times on safari browser
        load: _.debounce(function (params) {
            let self = this;

            let i = params.counter;
            let idexx_lab_id = params.idexx_lab_id;
            let lab_ids = params.lab_ids;
            let mod = params.module;
            let type = params.type;
            let url = params.module_url;
            let urls = params.idexx_url;
            let connection_error = params.connection_error;
            let lab_connection_error = params.lab_connection_error;
            let isEstimate = params.isEstimate;

            if (urls[i]) {
                // --- first time load, close item dialog
                //check if current url is empty, if not empty, set url as iframe src
                //if empty, go to next url and call iframe modal again

                this.iframe.src = urls[i];
                this.iframe.style = {
                    position: "absolute",
                    width: "100%",
                    height: "550px"
                };
                this.iframe.wrapperStyle = {
                    overflow: "hidden"
                };

                urls[i] = "";
            } else {
                i++;

                if (
                    typeof urls[i] !== "undefined" &&
                    urls[i] != null &&
                    urls[i] != ""
                ) {
                    let idexx_params = {
                        idexx_iframe: true,
                        counter: i,
                        idexx_lab_id: idexx_lab_id,
                        idexx_url: urls,
                        lab_ids: lab_ids,
                        module: mod,
                        module_url: url,
                        type: type,
                        isEstimate: isEstimate
                    };

                    self.close();

                    //load idexx submit modal again
                    setTimeout(() => {
                        self.$root.$emit("call_idexx_iframe", idexx_params);
                    }, 1000);
                    // record_model.call_iframe(idexx_params);
                } else {
                    // --- second time load, hide submit order dialog and display requisition dialog
                    self.close();

                    if (type == "single") {
                        if (
                            typeof idexx_lab_id !== "undefined" &&
                            idexx_lab_id != null &&
                            idexx_lab_id != ""
                        ) {
                            //load single requisition form modal
                            let print_lab_params = {
                                lab_id: idexx_lab_id,
                                module: mod,
                                url: url
                            };

                            // TODO : shouldnt call this at all if IDEXX_DEVICE
                            self._print_requisition_dialog(
                                print_lab_params
                            ).then(function (lab_response) {
                                if (
                                    lab_response.lab &&
                                    lab_response.lab.source.indexOf(
                                        "IDEXX_DEVICE:"
                                    ) != 0
                                ) {
                                    //load requisition form modal other than IDEXX_DEVICE

                                    lab_response.module_url = url;
                                    lab_response.module = mod;
                                    lab_response[
                                        "connection_error"
                                    ] = connection_error;
                                    lab_response[
                                        "lab_connection_error"
                                    ] = lab_connection_error;

                                    self.$root.$emit(
                                        "call-requisition-modal",
                                        lab_response
                                    );
                                } else {
                                    // for IDEXX_DEVICE reload page & open a new invoice tab
                                    self.$root.$emit("idexx-reload");

                                    if (!isEmpty(url)) {
                                        window.open(
                                            process.env.APPS +
                                                "index.php/" +
                                                url,
                                            "_blank"
                                        );
                                    }
                                }
                            });
                        } else {
                            if (!isEmpty(url)) {
                                this.redirectToPage(mod, url, isEstimate);
                            }
                        }
                    } else if (type == "multiple") {
                        if (
                            typeof idexx_lab_id !== "undefined" &&
                            idexx_lab_id != null &&
                            idexx_lab_id != ""
                        ) {
                            //load multiple requisition form modal
                            let print_lab_params = isEstimate
                                ? {
                                      lab_ids: lab_ids,
                                      idexx_ids: idexx_lab_id,
                                      module: mod,
                                      url: url
                                  }
                                : {
                                      ids: lab_ids,
                                      idexx_id: idexx_lab_id,
                                      module: mod,
                                      url: url
                                  };

                            let printMultipleReqForm = isEstimate
                                ? self._print_multiple_requisition_dialog_in_estimate(
                                      print_lab_params
                                  )
                                : self._print_multiple_requisition_dialog(
                                      print_lab_params
                                  );

                            printMultipleReqForm.then(function (lab_response) {
                                //load requisition form modal
                                lab_response.module_url = url;
                                lab_response.module = mod;
                                lab_response[
                                    "connection_error"
                                ] = connection_error;
                                lab_response[
                                    "lab_connection_error"
                                ] = lab_connection_error;

                                self.$root.$emit(
                                    "call-multirequsition-modal",
                                    lab_response
                                );
                            });
                        } else {
                            if (!isEmpty(url)) {
                                this.redirectToPage(mod, url);
                            }
                        }
                    }
                }
            }
        }, 400),
        redirectToPage(mod, url, isEstimate) {
            switch (mod) {
                case "patient":
                case "soap":
                    window.location.href =
                        process.env.APPS + "index.php/" + url;
                    break;
                case "client_profile":
                case "invoice_dashboard":
                    if (isEstimate) {
                        window.location.href =
                            process.env.APPS + "index.php/" + url;
                    } else {
                        window.open(
                            process.env.APPS + "index.php/" + url,
                            "_blank"
                        );
                    }
                    break;
                default:
                    break;
            }
        },
        close() {
            this.$refs.modalidexxsubmit.hide();

            // to make sure event "dialog-closed" is called only when the user click close or when the dialog is opened
            if (this.allowCloseDialog) {
                this.$root.$emit("dialog-closed");
                this.allowCloseDialog = false;
            }
        }
    }
};
</script>
<style>
@media only screen and (min-width: 1240px) {
    #modalidexxsubmit .searchWrapper h1.brandLogo {
        width: 170px;
        background-position-y: 11px;
    }

    #modalidexxsubmit .searchWrapper .textField {
        width: 90%;
    }
}

@media (max-width: 979px) {
    #modalidexxsubmit.modal.fade.in {
        top: 0px;
        left: 0px;
    }
}

@media only screen and (max-width: 1240px) {
    .row-fluid div.header-dropdown-menu.span4 {
        width: auto;
    }
}

@media only screen and (max-width: 1240px) and (min-width: 780px) {
    #modalidexxsubmit .searchWrapper .textField {
        width: 90% !important;
    }
}

#modalidexxsubmit .modal-body {
    background-color: white;
    padding: 0px;
}
#modalidexxsubmit .formFields {
    width: 76%;
}

#modalidexxsubmit .formFields .searchTextField {
    margin: 0px;
    border: 0;
    box-shadow: none;
    transition: none;
}

#modalidexxsubmit .formFields .searchButton {
    margin: 0px;
    text-align: right;
}

/*
Fixed Issus VET-2301, unable to scroll horizontally on smaller screen
*/
#modalidexxsubmit {
    overflow-x: auto;
}
</style>
